'use client';

import { useEffect, useState } from 'react';
import styles from './ThemeToggle.module.css';

export default function ThemeToggle({ label = 'Переключить тему', showName = true }: { label?: string; showName?: boolean }) {
    const [theme, setTheme] = useState<'dark' | 'light'>('dark');
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        const savedTheme = localStorage.getItem('theme') as 'dark' | 'light' | null;
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const initialTheme = savedTheme || (prefersDark ? 'dark' : 'light');
        setTheme(initialTheme);
        document.documentElement.setAttribute('data-theme', initialTheme);
    }, []);

    const toggleTheme = () => {
        const newTheme = theme === 'dark' ? 'light' : 'dark';
        setTheme(newTheme);
        document.documentElement.setAttribute('data-theme', newTheme);
        localStorage.setItem('theme', newTheme);
    };

    // Prevent hydration mismatch
    if (!mounted) {
        return (
            <button className={styles.button} type="button" aria-label={label}>
                <span className={styles.icon} aria-hidden="true">
                    🌙
                </span>
                {showName ? <span>Тёмная</span> : null}
            </button>
        );
    }

    return (
        <button className={styles.button} type="button" onClick={toggleTheme} aria-label={label}>
            <span className={styles.icon} aria-hidden="true">
                {theme === 'dark' ? '🌙' : '☀️'}
            </span>
            {showName ? <span>{theme === 'dark' ? 'Тёмная' : 'Светлая'}</span> : null}
        </button>
    );
}
